/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Cta_TitleInputs */

const en_how_we_work_cta_title = /** @type {(inputs: How_We_Work_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let’s find the system worth building.`)
};

const lv_how_we_work_cta_title = /** @type {(inputs: How_We_Work_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atradīsim sistēmu, ko vērts izveidot.`)
};

/**
* | output |
* | --- |
* | "Let’s find the system worth building." |
*
* @param {How_We_Work_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_cta_title = /** @type {((inputs?: How_We_Work_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_cta_title(inputs)
	return en_how_we_work_cta_title(inputs)
});